// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__AgdbX","header":"ClearentDisclaimer_header__3_pSR","inner":"ClearentDisclaimer_inner__1YeHb"};